export const FRESHCHAT_WIDGET_URL = '//fw-cdn.com/11317239/4007350.js';
export const FRESHCHAT_TOPIC = 'default_chat';
export const FRESHCHAT_SCRIPT_ID = 'freshchat_script';
